// extracted by mini-css-extract-plugin
export var container = "_d4-0";
export var icon = "_d4-1";
export var text = "_d4-2";